import { Link } from 'react-router-dom';

import { ClientMarquee } from "../../Home/Child/clients"; 
import { Icon } from '@iconify/react';
import {
    ConsultLottieIcon,
    SoftwareLottieIcon,
    integrateLottieIcon,
    webLottieIcon,
    legacyLottieIcon,
    supportLottieIcon
} from '../../Utils/lottie-icon';

const Video = "/Assets/videos/aboutus/motion-video-aboutus-480p.webm"
const Video2 = "/Assets/videos/aboutus/gradient2-480p-12s.webm"
const YellowGradient = "/Assets/videos/yellow-black-gradient-6s-480p.webm"
const RainbowGradient = "/Assets/videos/rainbow-480p.webm"
// const BlueYellow = "/Assets/videos/blue-yellow.mp4"

// const CarouselSwiperOption = {
//     slidesPerView: 4,
//     spaceBetween: 10,
//     breakpoints: {
//         0: {
//         slidesPerView: 1,
//         spaceBetween: 10,
//         },
//         689: {
//         slidesPerView: 2,
//         spaceBetween: 10,
//         },
//         989: {
//         slidesPerView: 3,
//         spaceBetween: 10,
//         },
//         1150: {
//         slidesPerView: 3,
//         spaceBetween: 32,
//         },
//     },
// };

const posts = [
    {
        id: "automation",
        title: "Workflow & Archives Automation",
        shortTitle: "Automation",
        img: "https://cdn.pixabay.com/photo/2019/12/17/14/43/christmas-4701783__340.png",
        icon: "",
        lottieIcon: {
            className: 'w-[90%] h-[90%] top-0 bottom-0 right-0 left-0 m-auto',
            path: ConsultLottieIcon
        },
        video: Video,
        descr: "We modernize legacy operations with end-to-end digital workflow systems and smart archiving for media, government, and regulatory bodies",
        pageTitle: 'Digitize, index, retrieve, and control your information with intelligence',
        serviceList: [
            {
                name: 'Custom Development',
			    link: 'custom-dev',
            },
            {
                name: 'Mobile Operations',
			    link: 'mobile-operation',
            },
            {
                name: 'Fintech',
			    link: 'fintech',
            }
        ],
        content: {
            title: 'Let\'s Build Your Next Big Move Together',
            banner: '/Assets/images/banner/consultation.webp',
            body: [
                {
                    type: 'text',
                    content: {
                        header: 'Your Partner for Reliable, Future-Proof IT Solutions',
                        paragraph: 'At MXI Solutions, our IT consultation services are designed to help businesses of all sizes harness technology that truly meets their needs. From assessing your current systems to designing strategic, future-proof solutions, we focus on making your business processes smarter, faster, and more secure.'
                    },
                    headerClass: "desk1:text-center tab1:text-center",
                    classname: "mb-8 stab1:text-center smob1:!mb-12 smob1:text-justify smob1:px-4"
                },
                {
                    type: 'imageAndPoint',
                    content: {
                        header: 'Solutions Include:',
                        listIcons: <Icon className="text-[#208bf2] text-5xl smob1:!text-[2rem]" icon="ei:arrow-right" />,
                        list: [
                            'Broadcast & Media Archives',
                            'Enterprise Document Management (EDMS)',
                            'Intelligent Approval Chains',
                            'Secure E-Forms & Audit Trails',
                            'Automated Record Lifecycle Management'
                        ],
                        video: Video,
                        image: '/Assets/images/banner/consult_text.webp',
                        imagefit: "object-contain",
                        headerClass: "tab1:text-center",
                    },
                    headerClass: "smob1:text-center",
                    classname: "mb-16 smob1:!mb-8"
                },
                {
                    type: 'text',
                    content: {
                        header: 'Service Available',
                        paragraph: 'We\'re dedicated to putting your needs first, crafting solutions that align with your goals—not ours. We believe in building long-term partnerships, where your success is our top priority. Here are the services provided by MXI:',
                    },
                    headerClass: "stab1:text-center",
                    classname: "my-8 tab1:!mb-8 stab1:text-center smob1:px-4 smob1:!mb-4 smob1:text-justify"
                },
                {
                    type: 'swiper',
                    content: {
                        data: [{
                            title:'Custom Software',
                            img:'/Assets/images/banner/software-dev.webp',
                            swiperTextClass: 'bottom-0 top-0 my-auto text-3xl max-w-[70%] drop-shadow-xl text-center text-white text-shadow my-auto left-0 right-0 mx-auto w-fit h-fit'
                        },{
                            title:'App Development',
                            img:'/Assets/images/banner/app-dev.webp',
                            swiperTextClass: 'bottom-0 top-0 my-auto text-3xl max-w-[70%] drop-shadow-xl text-center text-white text-shadow my-auto left-0 right-0 mx-auto w-fit h-fit'
                        },{
                            title:'Web Design',
                            img:'/Assets/images/banner/web-design.webp',
                            swiperTextClass: 'bottom-0 top-0 my-auto text-3xl max-w-[70%] drop-shadow-xl text-center text-white text-shadow my-auto left-0 right-0 mx-auto w-fit h-fit'
                        },{
                            title:'System Integrations',
                            img:'/Assets/images/banner/integrated-system.webp',
                            swiperTextClass: 'bottom-0 top-0 my-auto text-3xl max-w-[70%] drop-shadow-xl text-center text-white text-shadow my-auto left-0 right-0 mx-auto w-fit h-fit'
                        },{
                            title:'Network Infrastructure',
                            img:'/Assets/images/banner/network-infra.webp',
                            swiperTextClass: 'bottom-0 top-0 my-auto text-3xl max-w-[70%] drop-shadow-xl text-center text-white text-shadow my-auto left-0 right-0 mx-auto w-fit h-fit'
                        },{
                            title:'Disaster Planning & Recovery',
                            img:'/Assets/images/banner/recovery.webp',
                            swiperTextClass: 'bottom-0 top-0 my-auto text-3xl max-w-[70%] drop-shadow-xl text-center text-white text-shadow my-auto left-0 right-0 mx-auto w-fit h-fit'
                        },{
                            title:'Legacy Product Upgrade',
                            img:'/Assets/images/banner/legacy-upgrade.webp',
                            swiperTextClass: 'bottom-0 top-0 my-auto text-3xl max-w-[70%] drop-shadow-xl text-center text-white text-shadow my-auto left-0 right-0 mx-auto w-fit h-fit'
                        }]
                    },
                    classname: 'mb-24 smob1:!mb-12'
                },
                {
                    type: 'text',
                    content: {
                        header: 'Honorable Clients',
                        paragraph: 'At MXI, we have experience across diverse industries, from financial services to retail. Our team\'s versatility and laser focus on delivering clients\' goals is something we\'re proud of.<br/><br/> Here is a list of clients we\'ve had the opportunity to work with.',
                    },
                    headerClass: "tab1:text-center",
                    classname: "mb-8 smob1:mt-4 smob1:mb-4 smob1:px-4 smob1:text-justify"
                },{
                    type: 'component',
                    component: <ClientMarquee/>,
                    classname: "clients-container w-full mb-24 smob1:mb-16"
                }
                // ,{
                //     type: 'linkparagraph',
                //     content: {
                //         header: 'Finally...',
                //         paragraph: <p>Finding the right partner to bring your vision to life can be a daunting task. Building a solution to an IT problem goes beyond just programming and building IT infrastructure.<br/><br/>It also includes a deep understanding of client goals and pain points to create a solution that's truly right for them. Finding a partner with extensive experience is therefore very critical.<br/><br/>Click <Link style={{textDecoration:'underline', color:'#208bf2'}} to="/portfolio">here</Link> to learn more about our previous projects and ventures.</p>,
                //     },
                //     headerClass: "desk1:text-center smob1:text-left",
                //     classname: "mb-8 smob1:px-4 smob1:!mb-12 smob1:text-justify"
                // }
            ]
	    }
    },
    {
        id: "custom-dev",
        title: " Custom Software Development",
        shortTitle: "Software Development",
        img: "https://cdn.pixabay.com/photo/2019/12/17/14/43/christmas-4701783__340.png",
        icon: "",
        lottieIcon:{
            className: 'w-[80%] h-[80%] top-0 bottom-0 right-0 left-0 m-auto',
            path: SoftwareLottieIcon
        },
        video: Video2,
        descr: "We specialize in crafting bespoke enterprise software infused with artificial intelligence, delivering actionable intelligence, adaptive workflows, and data-driven decisions in real time.",
        serviceList: [
            {
                name: 'Network',
			    link: 'network',
            },
            {
                name: 'Mobile-Operations',
			    link: 'mobile-operation',
            },
            {
                name: 'Web Design',
			    link: 'web-design',
            },
        ],
        content: {
            title: 'Let\'s Build Your Next Big Move Together',
            banner: '/Assets/images/banner/app-development-banner.webp',
            images: ['/Assets/images/image-placeholder.png', '/Assets/images/image-placeholder.png'],
            body: [
                {
                    type: 'text',
                    content: {
                        header: 'Tailored Just For You',
                        paragraph: 'Custom software goes beyond off-the-shelf options, offering you a scalable, flexible, and precisely crafted solution that adapts to your unique business challenges as it grows. From initial concept to launch, we manage every stage of the development process with a focus on delivering results that empower your business to achieve more'
                    },
                    headerClass: "desk1:text-center tab1:text-center",
                    classname: "mb-8 smob1:!mb-12 stab1:text-center smob1:text-justify smob1:px-4"
                },
                {
                    type: 'imageAndPoint',
                    content: {
                        header: 'Includes',
                        list: [
                            'AI-enhanced Enterprise Systems.',
                            'Predictive Analytics Platforms',
                            'Multi-role User Portals & Dashboards',
                            'NLP & Voice-Control Interfaces',
                            'API-based Integrations with Legacy Systems',
                            'Compliance & Governance Modules'
                        ],
                        video: YellowGradient,
                        image: '/Assets/images/banner/softwaredev_text.webp',
                        imagefit: "object-contain",
                        headerClass: "tab1:text-center",
                    },
                    classname: "mb-32 stab1:mb-20 smob1:!mb-8"
                },
                {
                    type: 'text',
                    content: {
                        header: 'It\'s All About Attention to Detail',
                        paragraph: 'Building software can be a challenging task. Attention to detail and a forward-thinking mindset are crucial for developing software that not only benefits its users but is also future-proof for years to come. Hiring someone who isn\'t up to the job can be costly and frustrating.<br/><br/> At MXI Solutions, we take pride in our broad experience across various industries. Here are some of the companies we\'ve had the pleasure of working with.'
                    },
                    headerClass: "stab1:text-center",
                    classname: "mb-4 my-8 tab1:!mb-8 stab1:text-center smob1:px-4 smob1:!mb-4 smob1:text-justify"
                },
                {
                    type: 'component',
                    component: <ClientMarquee/>,
                    classname: "clients-container w-full mb-16 smob1:mb-8"
                },
                {
                    type: 'linkparagraph',
                    content: {
                        paragraph: <p>Click <Link style={{textDecoration:'underline', color:'#208bf2'}} to="../portfolio">here</Link> if you`re interested in learning more about our previous projects.</p>
                    },
                    classname: "stab1:!mb-16 stab1:text-center smob1:px-4 smob1:!mb-4 smob1:text-justify"
                },
                {
                    type: 'text',
                    content: {
                        header: 'Service Available',
                        paragraph: 'In addition to software development, we also offer a range of specialized services designed to support your business at every stage of growth. We tailored solutions to ensure that each aspect of your technology ecosystem is optimized and <b>aligned with your goals</b>.<br/><br/>Here\'s a look at some of the additional services we proudly offer:',
                    },
                    headerClass: "text-center smob1:text-center",
                    classname: "mb-4 my-8 stab1:!mb-12 stab1:text-center smob1:px-4 smob1:!mb-4 smob1:text-justify"
                },
                {
                    type: 'swiper',
                    content: {
                        data: [{
                            title:'Custom Software',
                            img:'/Assets/images/banner/software-dev.webp',
                            swiperTextClass: 'bottom-0 top-0 my-auto text-3xl max-w-[70%] drop-shadow-xl text-center text-white text-shadow my-auto left-0 right-0 mx-auto w-fit h-fit'
                        },{
                            title:'App Development',
                            img:'/Assets/images/banner/app-dev.webp',
                            swiperTextClass: 'bottom-0 top-0 my-auto text-3xl max-w-[70%] drop-shadow-xl text-center text-white text-shadow my-auto left-0 right-0 mx-auto w-fit h-fit'
                        },{
                            title:'Web Design',
                            img:'/Assets/images/banner/web-design.webp',
                            swiperTextClass: 'bottom-0 top-0 my-auto text-3xl max-w-[70%] drop-shadow-xl text-center text-white text-shadow my-auto left-0 right-0 mx-auto w-fit h-fit'
                        },{
                            title:'System Integrations',
                            img:'/Assets/images/banner/integrated-system.webp',
                            swiperTextClass: 'bottom-0 top-0 my-auto text-3xl max-w-[70%] drop-shadow-xl text-center text-white text-shadow my-auto left-0 right-0 mx-auto w-fit h-fit'
                        },{
                            title:'Network Infrastructure',
                            img:'/Assets/images/banner/network-infra.webp',
                            swiperTextClass: 'bottom-0 top-0 my-auto text-3xl max-w-[70%] drop-shadow-xl text-center text-white text-shadow my-auto left-0 right-0 mx-auto w-fit h-fit'
                        },{
                            title:'Disaster Planning & Recovery',
                            img:'/Assets/images/banner/recovery.webp',
                            swiperTextClass: 'bottom-0 top-0 my-auto text-3xl max-w-[70%] drop-shadow-xl text-center text-white text-shadow my-auto left-0 right-0 mx-auto w-fit h-fit'
                        },{
                            title:'Legacy Product Upgrade',
                            img:'/Assets/images/banner/legacy-upgrade.webp',
                            swiperTextClass: 'bottom-0 top-0 my-auto text-3xl max-w-[70%] drop-shadow-xl text-center text-white text-shadow my-auto left-0 right-0 mx-auto w-fit h-fit'
                        }]
                    },
                    classname: 'mb-24 smob1:!mb-8'
                },
                {
                    type: 'linkparagraph',
                    content: {
                        paragraph: <p>Click <Link style={{textDecoration:'underline', color:'#208bf2'}} to="/portfolio">here</Link> if you`re interested in learning more about our previous projects.</p>
                    },
                    classname: "stab1:!mb-16 stab1:text-center smob1:px-4 smob1:!mb-8 smob1:text-justify"
                }
            ],
            // questions: [
            //     {
            //         question: 'What is the design process for branding?',
            //         answer: 'Lorem ipsum dolor sit amet consectetur. Consectetur nec ultrices sed sed. Vivamus dolor cras aliquet scelerisque. Lorem ipsum dolor sit amet consectetur. Consectetur nec ultrices sed sed. Vivamus dolor cras aliquet scelerisque.'
            //     },
            //     {
            //         question: 'What is the design process for branding?',
            //         answer: 'Lorem ipsum dolor sit amet consectetur. Consectetur nec ultrices sed sed. Vivamus dolor cras aliquet scelerisque. Lorem ipsum dolor sit amet consectetur. Consectetur nec ultrices sed sed. Vivamus dolor cras aliquet scelerisque.'
            //     },
            //     {
            //         question: 'What is the design process for branding?',
            //         answer: 'Lorem ipsum dolor sit amet consectetur. Consectetur nec ultrices sed sed. Vivamus dolor cras aliquet scelerisque. Lorem ipsum dolor sit amet consectetur. Consectetur nec ultrices sed sed. Vivamus dolor cras aliquet scelerisque.'
            //     },
            //     {
            //         question: 'What is the design process for branding?',
            //         answer: 'Lorem ipsum dolor sit amet consectetur. Consectetur nec ultrices sed sed. Vivamus dolor cras aliquet scelerisque. Lorem ipsum dolor sit amet consectetur. Consectetur nec ultrices sed sed. Vivamus dolor cras aliquet scelerisque.'
            //     }
            // ],
	    }
    },
    {
        id: "network",
        title: "Secure Network Infrastructure & Command Platforms",
        shortTitle: "Network Infrastructure",
        img: "https://cdn.pixabay.com/photo/2019/12/17/14/43/christmas-4701783__340.png",
        icon: "",
        lottieIcon:{
            className: 'w-[90%] h-[90%] top-0 bottom-0 right-0 left-0 m-auto',
            path: integrateLottieIcon
        },
        video: Video,
        descr: "We engineer resilient and secure networks for mission-critical environments—supporting low-latency data ingestion, encrypted communication, and distributed operations.",
        serviceList: [
            {
                name: 'Mobile Operations',
			    link: 'mobile-operation',
            },
            {
                name: 'On Demand Support',
			    link: 'tech-support',
            },
            {
                name: 'Automation',
			    link: 'automation',
            },
        ],
        content: {
            title: 'The backbone of real-time intelligence. Built to perform under pressure.',
            banner: '/Assets/images/banner/sys-integration-banner.webp',
            images: ['/Assets/images/image-placeholder.png', '/Assets/images/image-placeholder.png'],
            body: [
                {
                    type: 'text',
                    content: {
                        header: 'Where Everything Runs Smoothly, Automatically',
                        paragraph: 'We approach system integration with a deep understanding of both the technical and strategic needs of your business. Our team ensures each system works in harmony, providing custom solutions that are scalable, secure, and designed with your future growth in mind.<br/><br/> With expertise across multiple platforms and technologies, we deliver seamless, end-to-end integration that eliminates bottlenecks and creates a smoother workflow across your entire organization.'
                    },
                    headerClass: "desk1:text-center tab1:text-center",
                    classname: "mb-24 stab1:text-center tab1:!mb-12 smob1:text-justify smob1:px-4"
                },
                {
                    type: 'imageAndPoint',
                    content: {
                        header: 'Core Offerings:',
                        list: [
                            'Hybrid Cloud Infrastructure Design',
                            'Encrypted WAN/LAN & Wireless Comms',
                            'Tactical Mobile Communications (DSNG, Command Vehicles)',
                            'Redundant Uplink & Data Sync Systems',
                            'AI-Driven Network Monitoring (anomaly, breach detection)'
                        ],
                        video: RainbowGradient,
                        image: '/Assets/images/banner/sysintegration_text.webp',
                        imagefit: "object-contain",
                        headerClass: "tab1:text-center",
                    },
                    
                    classname: "mb-28 stab1:mb-12 smob1:!mb-8"
                },
                {
                    type: 'text',
                    content: {
                        paragraph: 'Many companies face concerns about downtime, compatibility, and the potential for unexpected costs. Without the right partner, system integration can become complex, leaving gaps between your systems that result in inefficiencies and missed opportunities.<br/><br/>Our work is trusted by leading organizations that demand efficiency, reliability, and forward-thinking technology.'
                    },
                    classname: "my-8 stab1:mb-8 smob1:px-4 smob1:!mb-4 smob1:text-justify"
                },
                {
                    type: 'component',
                    component: <ClientMarquee/>,
                    classname: "clients-container w-full mb-24"
                },
            ],
	    }
    },
    {
        id: "fintech",
        title: "FinTech & RegTech Solutions",
        shortTitle: "Fintech Solution",
        img: "https://cdn.pixabay.com/photo/2019/12/17/14/43/christmas-4701783__340.png",
        icon: "",
        lottieIcon:{
            className: 'w-[90%] h-[90%] top-0 bottom-0 right-0 left-0 m-auto',
            path: webLottieIcon
        },
        video: Video,
        descr: "We develop transaction-ready platforms that combine performance, fraud protection, and regulatory compliance using embedded AI and blockchain-backed audit trails.",
        serviceList: [
            {
                name: 'App Development',
			    link: 'custom-dev',
            },
            {
                name: 'Automation',
			    link: 'automation',
            },
            {
                name: 'Tech Support',
			    link: 'tech-support',
            }
        ],
        content: {
            title: 'Agile, secure, and regulator-ready fintech platforms for digital finance',
            banner: '/Assets/images/banner/web-design-banner.webp',
            images: ['/Assets/images/image-placeholder.png', '/Assets/images/image-placeholder.png'],
            body: [
              {
                type: 'text',
                content: {
                  header: 'Trust and Innovation Matter',
                  paragraph: 'In fintech, sleek design must meet rock-solid performance. Our platforms ensure secure, compliant, and intuitive user experiences—from digital wallets to lending dashboards—empowering users to interact with confidence.'
                },
                headerClass: "desk1:text-center smob1:text-center",
                classname: "mb-20 text-center tab1:!mb-16 smob1:text-justify smob1:px-4"
              },
              {
                type: 'swiper',
                content: {
                  data: [{
                    title: 'Digital Wallet Platforms',
                    img: '/Assets/images/banner/software-dev.webp',
                    swiperTextClass: 'bottom-0 top-0 my-auto text-3xl max-w-[70%] drop-shadow-xl text-center text-white text-shadow my-auto left-0 right-0 mx-auto w-fit h-fit'
                  },{
                    title: 'Investment Apps',
                    img: '/Assets/images/banner/app-dev.webp',
                    swiperTextClass: 'bottom-0 top-0 my-auto text-3xl max-w-[70%] drop-shadow-xl text-center text-white text-shadow my-auto left-0 right-0 mx-auto w-fit h-fit'
                  },{
                    title: 'Fintech Web Portals',
                    img: '/Assets/images/banner/ecommerce.webp',
                    swiperTextClass: 'bottom-0 top-0 my-auto text-3xl max-w-[70%] drop-shadow-xl text-center text-white text-shadow my-auto left-0 right-0 mx-auto w-fit h-fit'
                  },{
                    title: 'KYC/AML Onboarding UX',
                    img: '/Assets/images/banner/web-design.webp',
                    swiperTextClass: 'bottom-0 top-0 my-auto text-3xl max-w-[70%] drop-shadow-xl text-center text-white text-shadow my-auto left-0 right-0 mx-auto w-fit h-fit'
                  }]
                },
                classname: 'mb-32 tab1:!mb-20'
              },
              {
                type: 'text',
                content: {
                  header: 'Our Fintech Approach',
                  paragraph: 'At MXI Solutions, we merge financial compliance with elegant UX. We start by understanding your regulatory needs, target markets, and growth goals. From there, we design seamless fintech interfaces that promote trust and usability across devices.'
                },
                headerClass: "desk1:text-center smob1:text-center",
                classname: "mb-20 text-center tab1:!mb-12 smob1:text-justify smob1:px-4"
              },
              {
                type: 'imageAndPoint',
                content: {
                  header: 'How We Deliver Fintech Experiences',
                  headerClass: "text-center",
                  list: [
                    '<b>Discovery & Compliance Review</b>:  We assess your market, product goals, and relevant financial regulations.',
                    '<b>Wireframes & Secure Prototypes</b>:  We design for trust, clarity, and ease of use in every transaction flow.',
                    '<b>Development & Pen Testing</b>:  Your platform is built with scalability and security top of mind.',
                    '<b>Deployment & Support</b>:  We launch and monitor your fintech product, providing long-term updates and care.'
                  ],
                  video: Video,
                  image: '/Assets/images/banner/web-design-impression.webp',
                  imagefit: "object-contain"
                },
                headerClass: "text-center smob1:text-center",
                classname:"mb-28 stab1:!mb-16 mob1:mb-10"
              },
              {
                type: 'text',
                content: {
                  paragraph: 'We\'ve worked with fintech startups, investment firms, and digital payment providers. Our team\'s deep technical expertise and commitment to compliance sets us apart.<br/><br/> Below are some of the industry leaders we\'ve partnered with.',
                },
                classname: "mb-8 smob1:mt-4 smob1:mb-8 smob1:px-4 smob1:text-justify"
              },
              {
                type: 'component',
                component: <ClientMarquee/>,
                classname: "clients-container w-full mb-24 stab1:mb-16 mob1:mb-10 "
              },
              {
                type: 'text',
                content: {
                  paragraph: 'In digital finance, your platform must be as reliable as your reputation.</br></br> <b>Let\'s build something secure, compliant, and future-ready.</b>',
                },
                classname: "mb-16 smob1:px-4 tab1:!mb-12 stab1:text-center smob1:text-justify"
              }
            ]
            // questions: [
            //     {
            //         question: 'What is the design process for branding?',
            //         answer: 'Lorem ipsum dolor sit amet consectetur. Consectetur nec ultrices sed sed. Vivamus dolor cras aliquet scelerisque. Lorem ipsum dolor sit amet consectetur. Consectetur nec ultrices sed sed. Vivamus dolor cras aliquet scelerisque.'
            //     },
            //     {
            //         question: 'What is the design process for branding?',
            //         answer: 'Lorem ipsum dolor sit amet consectetur. Consectetur nec ultrices sed sed. Vivamus dolor cras aliquet scelerisque. Lorem ipsum dolor sit amet consectetur. Consectetur nec ultrices sed sed. Vivamus dolor cras aliquet scelerisque.'
            //     },
            //     {
            //         question: 'What is the design process for branding?',
            //         answer: 'Lorem ipsum dolor sit amet consectetur. Consectetur nec ultrices sed sed. Vivamus dolor cras aliquet scelerisque. Lorem ipsum dolor sit amet consectetur. Consectetur nec ultrices sed sed. Vivamus dolor cras aliquet scelerisque.'
            //     },
            //     {
            //         question: 'What is the design process for branding?',
            //         answer: 'Lorem ipsum dolor sit amet consectetur. Consectetur nec ultrices sed sed. Vivamus dolor cras aliquet scelerisque. Lorem ipsum dolor sit amet consectetur. Consectetur nec ultrices sed sed. Vivamus dolor cras aliquet scelerisque.'
            //     }
            // ],
	    }
    },
    // {
    //     id: "graphic-design",
    //     title: "Graphic Design",
    //     shortTitle: "",
    //     img: "https://cdn.pixabay.com/photo/2019/12/17/14/43/christmas-4701783__340.png",
    //     icon: "",
    //     lottieIcon:{
    //         className: 'w-[90%] h-[90%] top-0 bottom-0 right-0 left-0 m-auto',
    //         path: artistLottieIcon
    //     },
    //     video: Video2,
    //     descr: "Deliver message in the most impactful way possible.",
    //     content: {
    //         title: 'Let’s Build Your Next Big Move Together',
    //         banner: '/Assets/images/image-placeholder.png',
    //         images: ['/Assets/images/image-placeholder.png', '/Assets/images/image-placeholder.png'],
    //         body: [
    //             {
    //                 type: 'text',
    //                 content: {
    //                     header: 'IT Solution And Business',
    //                     paragraph: 'The website design should be user-friendly, easy to navigate, and aesthetically pleasing.The website design should be user-friendly, easy to navigate.The website design should be user-friendly, easy to navigate, and aesthetically pleasing.The website design should be user-friendly, easy to navigate.The website design should be user-friendly, easy to navigate, and aesthetically pleasing.The website design should.'
    //                 }
    //             },
    //             {
    //                 type: 'imageAndPoint',
    //                 content: {
    //                     header: 'Service Features',
    //                     list: [
    //                         'We Provide Flexible IT Services',
    //                         'We Provide Flexible IT Services',
    //                         'We Provide Flexible IT Services',
    //                         'We Provide Flexible IT Services'
    //                     ],
    //                     image: '/Assets/images/image-placeholder.png'
    //                 }
    //             },
    //             {
    //                 type: 'text',
    //                 content: {
    //                     header: 'IT Solution And Business',
    //                     paragraph: 'The website design should be user-friendly, easy to navigate, and aesthetically pleasing.The website design should be user-friendly, easy to navigate.The website design should be user-friendly, easy to navigate, and aesthetically pleasing.The website design should be user-friendly, easy to navigate.The website design should be user-friendly, easy to navigate, and aesthetically pleasing.The website design should.'
    //                 }
    //             }
    //         ],
    //         questions: [
    //             {
    //                 question: 'What is the design process for branding?',
    //                 answer: 'Lorem ipsum dolor sit amet consectetur. Consectetur nec ultrices sed sed. Vivamus dolor cras aliquet scelerisque. Lorem ipsum dolor sit amet consectetur. Consectetur nec ultrices sed sed. Vivamus dolor cras aliquet scelerisque.'
    //             },
    //             {
    //                 question: 'What is the design process for branding?',
    //                 answer: 'Lorem ipsum dolor sit amet consectetur. Consectetur nec ultrices sed sed. Vivamus dolor cras aliquet scelerisque. Lorem ipsum dolor sit amet consectetur. Consectetur nec ultrices sed sed. Vivamus dolor cras aliquet scelerisque.'
    //             },
    //             {
    //                 question: 'What is the design process for branding?',
    //                 answer: 'Lorem ipsum dolor sit amet consectetur. Consectetur nec ultrices sed sed. Vivamus dolor cras aliquet scelerisque. Lorem ipsum dolor sit amet consectetur. Consectetur nec ultrices sed sed. Vivamus dolor cras aliquet scelerisque.'
    //             },
    //             {
    //                 question: 'What is the design process for branding?',
    //                 answer: 'Lorem ipsum dolor sit amet consectetur. Consectetur nec ultrices sed sed. Vivamus dolor cras aliquet scelerisque. Lorem ipsum dolor sit amet consectetur. Consectetur nec ultrices sed sed. Vivamus dolor cras aliquet scelerisque.'
    //             }
    //         ],
	//     }
    // },
    {
        id: "mobile-operation",
        title: "Mobile Operations & Rapid Deployment Units",
        shortTitle: "Mobile Operations",
        img: "https://cdn.pixabay.com/photo/2019/12/17/14/43/christmas-4701783__340.png",
        icon: "",
        lottieIcon:{
            className: 'w-[90%] h-[90%] top-0 bottom-0 right-0 left-0 m-auto',
            path: legacyLottieIcon
        },
        video: Video2,
        descr: "MXI delivers field-deployable communication and command systems, mounted on custom-built vehicles or mobile racks.",
        serviceList: [
            {
                name: 'Software Development',
			    link: 'custom-dev',
            },
            {
                name: 'Automation',
			    link: 'automation',
            },
            {
                name: 'Tech Support',
			    link: 'tech-support',
            }
        ],
        content: {
            title: 'Intelligence on the move. Power where you need it most.',
            banner: '/Assets/images/banner/legacy-upgrade-banner.webp',
            images: ['/Assets/images/image-placeholder.png', '/Assets/images/image-placeholder.png'],
            body: [
                {
                    type: 'text',
                    content: {
                      header: 'Intelligence on the Move. Power Where You Need It Most.',
                      paragraph: 'Whether in remote environments or critical urban zones, MXI’s Mobile Operations & Rapid Deployment Units ensure uninterrupted access to data, communication, and decision-making tools. Our field-deployable systems—mounted on custom vehicles or mobile racks—deliver secure uplinks, real-time video feeds, operational dashboards, and situational awareness for defense, disaster response, and high-pressure media scenarios.<br/><br/>Rapidly deployed and ruggedized for mission-critical success, these solutions put command and control right where the action happens.',
                    },
                    headerClass: "desk1:text-center smob1:text-center",
                    classname: "mb-20 text-center stab1:text-center tab1:!mb-10 smob1:text-justify smob1:px-4"
                },
                {
                    type: 'imageAndPoint',
                    content: {
                        header: 'Vehicle-Based Platforms',
                        headerClass: "text-center",
                        list: [
                            'DSNG (Digital Satellite News Gathering)',
                            'Mobile Command Centers',
                            'Tactical Surveillance & Comms Vans',
                            'Secure Live Feed Transmission & Edge Processing',
                        ],
                        video: YellowGradient,
                        image: '/Assets/images/banner/legacy_text.webp',
                        imagefit: "object-contain"
                    },
                    headerClass: "text-center smob1:text-center",
                    classname:"mb-24 tab1:!mb-16"
                },
                // {
                //     type: 'imageAndPoint',
                //     content: {
                //         header: 'The Process',
                //         list: [
                //             '<b>Assessment</b>: Gather requirements. Identifying critical pain points and opportunities for improvement.',
                //             '<b>Design & Strategy</b>:  This includes selecting modern technologies, defining new features, and creating a roadmap for implementation.',
                //             '<b>Development & Testing</b>:  Refactor old code, add new features, integrate modern components and testing. The goal is to enhance performance and scalability without disrupting existing workflows',
                //             '<b>Deployment & Support</b>:  We deploy the software to your environment with minimized downtime and provide ongoing support'
                //         ],
                //         image: '/Assets/images/image-placeholder.png'
                //     },
                //     classname: "mb-8"
                // },
                // {
                //     type: 'text',
                //     content: {
                //         paragraph: 'Upgrading a legacy product isn’t a task that just anyone can handle. It requires a specific set of skills, expertise, and strategic planning to ensure a smooth transition and a successful outcome:',
                //         dlist: [
                //             '<b>Client-Centered Approach</b>: Prioritizing the needs of the business and understanding goals of the upgrade is essential to enhance performance and user-experience of the system.',
                //             '<b>Problem-Solving Skills</b>: Legacy systems often have accumulated technical debt and undocumented features, making upgrades challenging.',
                //             '<b>Deep Understanding of Legacy Systems</b>: For making updates without breaking existing functionality.',    
                //             '<b>Experience with Data Migration</b>: To ensure data integrity, avoid data loss, and ensure smooth transitions.',
                //         ],
                //         dlist_position: 'top'
                //     },
                //     classname: "bg-gradient-to-r from-white to-white p-8 text-black border-2 border-gray-200 rounded-3xl",
                // },
                // {
                //     type: 'text',
                //     content: {
                //         paragraph: 'We take a strategic, step-by-step approach to upgrading legacy systems. We start by conducting a thorough assessment of your current software, identifying critical pain points and opportunities for improvement. Our team then creates a tailored plan that prioritizes data integrity, security, and seamless integration with your existing infrastructure.'
                //     },
                //     classname: ""
                // },
                {
                    type: 'text',
                    content: {
                      paragraph: 'At MXI Solutions, we take pride in empowering mission-critical operations across sectors such as defense, emergency response, telecommunications, and media. Below are some of the organizations we’ve had the honor of supporting in the field.'
                    },
                    classname: "text-center mb-8 tab1:mt-4 tab1:mb-4 smob1:px-4 smob1:text-justify"
                },
                {
                    type: 'component',
                    component: <ClientMarquee/>,
                    classname: "clients-container w-full mb-24 tab1:mb-16"
                },
                {
                    type: 'text',
                    content: {
                        paragraph: 'From mobile command centers to tactical video and data streaming, we\'ve helped clients modernize their operational infrastructure with rugged, rapidly deployable units.<br/><br/>These solutions have improved real-time decision-making, field safety, and coordination in critical moments.<br/><br/><b>Contact us today</b> for a Free Consultation,<br/><br/>and discover how mobile tech can give your team the field advantage it needs.'
                    },
                    classname: "text-center mb-12 smob1:px-4 smob1:!mb-12 smob1:text-justify"
                }
            ],
            questions: [
                {
                  question: 'What is the process of deploying a Mobile Command Unit?',
                  answer: '<ul style="list-style:disc;"><li><b>Requirements Gathering</b>: Identify the operational needs, deployment conditions, and communication protocols.</li><li><b>Design & Configuration</b>: Define equipment layout, connectivity (e.g., satellite, LTE), and onboard software integration.</li><li><b>Deployment & Testing</b>: Deliver and test the unit in live field conditions to ensure performance and redundancy.</li><li><b>Support & Training</b>: Ongoing support and user training to ensure optimal use in high-pressure environments.</li></ul>'
                },
                {
                  question: 'How\'s the procurement process?',
                  answer: 'We work with flexible procurement models—whether it\'s direct purchase, lease, or phased rollout. Our team aligns with your operational and budgetary requirements, including support for government bidding or private sector scaling.'
                }
            ]
	    }
    },
    {
        id: "tech-support",
        title: "Technical Support",
        shortTitle: "Technical Support",
        img: "https://cdn.pixabay.com/photo/2019/12/17/14/43/christmas-4701783__340.png",
        icon: "",
        lottieIcon:{
            className: 'w-[90%] h-[90%] top-0 bottom-0 right-0 left-0 m-auto',
            path: supportLottieIcon
        },
        video: Video,
        descr: 'Evolving technology demands evolving support - we\'ve got you covered.',
        serviceList: [
            {
                name: 'Automation',
			    link: 'automation',
            },
            {
                name: 'Fintech',
			    link: 'fintech',
            },
            {
                name: 'App Development',
			    link: 'custom-dev',
            },
        ],
        content: {
            title: 'Let\'s Build Your Next Big Move Together',
            banner: '/Assets/images/banner/tech-support-banner.webp',
            images: ['/Assets/images/image-placeholder.png', '/Assets/images/image-placeholder.png'],
            body: [
                {
                    type: 'text',
                    content: {
                        header: 'Evolving Technology Demands Evolving Support',
                        paragraph: 'We offer proactive, responsive, and reliable support tailored to your unique needs, so you can focus on what matters most—growing your business.'
                    },
                    headerClass: "text-center smob1:text-center",
                    classname: "mb-20 text-center smob1:!mb-12 smob1:text-justify smob1:px-4"
                },
                {
                    type: 'imageAndPoint',
                    content: {
                        header: 'Who Need It?',
                        headerClass: "text-center",
                        list: [
                            'In today\'s digital age, technology is the backbone of any business. Even a minor glitch can disrupt your workflow, slow down productivity, and impact your business.<br/><br/>Without reliable technical support, you risk facing recurring issues, unexpected downtime, and frustrated users.',
                            
                        ],
                        video: YellowGradient,
                        image: '/Assets/images/banner/support_text.webp',
                        imagefit: "object-contain"
                    },
                    headerClass: "text-center smob1:text-center",
                    classname: "mb-24 text-center mx-auto stab1:mb-16 smob1:!mb-12"
                },
                {
                    type: 'text',
                    content: {
                        paragraph: 'Our Technical Support Services are designed to help you resolve issues quickly, minimize downtime, and keep your operations running seamlessly. It\'s not just about fixing problems—it\'s about preventing them before they happen and giving you peace of mind.'
                    },
                    classname: "mb-20 tab1:!mb-16 tab1:text-justify smob1:px-4",
                },
                {
                    type: 'text',
                    content: {
                        header: 'Services Provided',
                        paragraph: 'Here are the common types of technical support services we provided:',
                    },
                    headerClass: "tab1:text-center",
                    classname: "mb-16 smob1:px-4 tab1:!mb-8 tab1:text-center",
                },{
                    type: 'swiper',
                    content: {
                        data: [{
                            title:'Software Installations & Updates',
                            img:'/Assets/images/banner/software-dev.webp',
                            swiperTextClass: 'bottom-0 top-0 my-auto text-3xl max-w-[70%] drop-shadow-xl text-center text-white text-shadow my-auto left-0 right-0 mx-auto w-fit h-fit'
                        },{
                            title:'System Optimizations',
                            img:'/Assets/images/banner/app-dev.webp',
                            swiperTextClass: 'bottom-0 top-0 my-auto text-3xl max-w-[70%] drop-shadow-xl text-center text-white text-shadow my-auto left-0 right-0 mx-auto w-fit h-fit'
                        },{
                            title:'Hardware & Network Support',
                            img:'/Assets/images/banner/ecommerce.webp',
                            swiperTextClass: 'bottom-0 top-0 my-auto text-3xl max-w-[70%] drop-shadow-xl text-center text-white text-shadow my-auto left-0 right-0 mx-auto w-fit h-fit'
                        },{
                            title:'Cloud Support',
                            img:'/Assets/images/banner/web-design.webp',
                            swiperTextClass: 'bottom-0 top-0 my-auto text-3xl max-w-[70%] drop-shadow-xl text-center text-white text-shadow my-auto left-0 right-0 mx-auto w-fit h-fit'
                        },{
                            title:'Disaster & Recovery Support',
                            img:'/Assets/images/banner/web-design.webp',
                            swiperTextClass: 'bottom-0 top-0 my-auto text-3xl max-w-[70%] drop-shadow-xl text-center text-white text-shadow my-auto left-0 right-0 mx-auto w-fit h-fit'
                        }]
                    },
                    classname: 'mb-32 smob1:!mb-12'
                },
                // {
                //     type: 'text',
                //     content: {
                //         header: 'Services Provided',
                //         paragraph: 'Here are the common types of technical support services we provided:',
                //         dlist: [
                //             '<b>Software Installations & Updates</b>',
                //             '<b>System Optimizations</b>',
                //             '<b>Hardware & Network Support</b>.',    
                //             '<b>Cloud Support</b>',
                //             '<b>Disaster & Recovery Support</b>'
                //         ],
                //         dlist_position: 'center'
                //     },
                //     classname: "mb-16",
                // },
                {
                    type: 'text',
                    content: {
                        header: 'Our Work Speak for Itself',
                        paragraph: 'Our clients range from small businesses to large enterprises, all of whom trust MXI Solutions for dependable technical support.<br/><br/>Here are some of the companies we\'ve had the pleasure of working with.'
                    },
                    headerClass: "tab1:text-center",
                    classname: "mb-8 stab1:text-center smob1:mt-4 smob1:mb-4 smob1:px-4 smob1:text-justify"
                },
                {
                    type: 'component',
                    component: <ClientMarquee/>,
                    classname: "clients-container w-full mb-16 smob1:mb-8"
                },
                {
                    type: 'text',
                    content: {
                        paragraph: 'At MXI Solutions, we offer more than just basic troubleshooting. <br/><br/>Our team of skilled technicians provides end-to-end support, including issue diagnosis, timely resolution, and proactive monitoring to prevent future problems.<br/><br/>Contact us now to learn more :)'
                    }, 
                    classname: "mb-12 stab1:text-center smob1:px-4 tab1:!mb-10 smob1:text-justify"
                }
            ]
	    }
    },
];

export default posts;